import { render, staticRenderFns } from "./companyModal.vue?vue&type=template&id=73533be5&scoped=true&"
import script from "./companyModal.vue?vue&type=script&lang=js&"
export * from "./companyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73533be5",
  null
  
)

export default component.exports